export * from './legals.models';
export * from './legals.service';
